const theme = {
  breakpoint: {
    Sm: '@media (min-width: 600px)',
    LtSm: '@media (max-width: 599px)',
    Md: '@media (min-width: 900px)',
    LtMd: '@media (max-width: 899px)',
    MdLtLg: '@media (min-width: 900px) and (max-width: 1199px)',
    Lg: '@media (min-width: 1200px)',
    LtLg: '@media (max-width: 1199px)',
    Xl: '@media (min-width: 1400px)',
    LtXl: '@media (max-width: 1399px)',
  },
  market: {
    no: "[data-market='NO'] &",
    noRoot: "&[data-market='NO']",
    se: "[data-market='SE'] &",
    seRoot: "&[data-market='SE']",
  },
  font: {
    size: {
      xxxsmall: '0.5625rem',
      xxsmall: '0.625rem',
      xsmall: '0.75rem',
      small: '0.875rem',
      regular: '1rem',
      large: '1.125rem',
      xlarge: '1.25rem',
      xxlarge: '1.5rem',
    },
    lineHeight: {
      main: '1.5',
      alt: '1.3', // TODO: Change name to lineHeight.thin
      heading: '1.2', // TODO: Use for headings
    },
  },
  distances: {
    baseUnit: '8px',
    inputHeight: '52px',
    containerMaxWidth: '1440px',
    contentMaxWidth: '560px',
  },
  boxshadow: {
    main: '0 1px 4px rgba(0, 0, 0, 0.05)',
    large:
      '0px 8px 10px rgba(0, 0, 0, 0.03), 0px 2px 14px rgba(0, 0, 0, 0.03), 0px 2px 5px rgba(0, 0, 0, 0.09)',
  },
  mask: {
    gradient: {
      toTop: 'linear-gradient(to top, #000, transparent)',
      toBottom: 'linear-gradient(to bottom, #000, transparent)',
      toLeft: 'linear-gradient(to left, #000, transparent)',
      toRight: 'linear-gradient(to right, #000, transparent)',
    },
  },
  zindex: {
    inputDatePopper: '10',
    incidentAlert: '11',
    mainNavigationFoldout: '20',
    floatingbar: '80',
    pageLayoutSticky: '80',
    floatingChatBubble: '81',
    panel: '85',
    panelSortableItem: '86', // Needs to be higher than panel
    entityExplorer: '87',
    lightbox: '89',
    snackbar: '90',
    mainNavigationOverlay: '94',
    mainNavigation: '95',
    globalSearch: '96',
    focusskip: '100',
  },
};

export type Theme = typeof theme;
export default theme;
